import { Box, Dialog as CommonDialog, Flex, type DialogProps } from 'components'
import { useContext } from 'react'
import { forceDark } from 'utils'
import { ScaleProps, useScale, useScaleProps } from '../../utils/scaleUtils'
import { ExplorerConfigContext } from '../providers/ExplorerConfigProvider'
import SIcon from './SIcon'
import SText from './SText'
import SView from './SView'

export interface Props extends ScaleProps<DialogProps> {}

export default function SDialog({ children, contentProps, title, w, ...dialogProps }: Props) {
  const scale = useScale()
  const { theme } = useContext(ExplorerConfigContext)
  const { styleProps, rest } = useScaleProps(dialogProps || {})

  return (
    <CommonDialog
      placement="center"
      hideClose
      contentProps={{
        display: 'flex',
        overflow: 'hidden',
        backgroundColor: '#00000077',
        maxHeight: `${800 * scale}px`,
        maxW: `${1200 * scale}px`,
        width: w ? (typeof w === 'number' ? `${w * scale}px` : w) : 'auto',
        ...contentProps,
      }}
      bodyProps={{ display: 'flex' }}
      backdropProps={{
        bg: 'blackAlpha.300',
        backdropFilter: 'blur(10px)',
      }}
      {...rest}
    >
      <Box {...forceDark} display="flex" flexDirection="column" flex={1}>
        <Flex direction="column" overflow="auto" color="inherit" {...styleProps}>
          {children}
        </Flex>
        {title && (
          <SView
            color="black"
            direction="row"
            justifyContent="space-between"
            py={20}
            px={20}
            align="center"
            backgroundColor={theme.color.primary}
          >
            {typeof title === 'string' ? (
              <SText fontSize={25} fontWeight="bold">
                {title}
              </SText>
            ) : (
              title
            )}
            <SIcon cursor="pointer" fontSize={25} onClick={dialogProps.onClose} value="close" />
          </SView>
        )}
      </Box>
    </CommonDialog>
  )
}
